<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onDismiss()">Back</button>
  <button mat-raised-button color="primary" *ngIf="isDeactivate" (click)="onDeactivate()">Deactivate</button>
  <button mat-raised-button color="primary" *ngIf="isScheduledDeactivate" (click)="onScheduledDeactivate()">Schedule deactivation</button>
</mat-dialog-actions>
